require('./chatMembers/chatMembersComponent.js');

const locale = require('./collaborationChat.i18n.json');

/*@ngInject*/
const CollaborationChatController = function ($interval, $rootScope, $scope, $state, $stateParams, $location, $timeout, $uibModal, coreConstant,
    currentUserModel, currentSubmissionModel, submissionStatus, coreMediator, collaborationMediator, submissionConstant, appTypeConfigurationModel, authorizationConstants, preferenceModel) {

    const timeoutList = [];

    let chatMemberIntervalObject,
        chatMemberListPollingInterval;

    $scope.i18n = locale;

    $scope.chatViewModel = {
        submissionId: null,
        searchPlaceholder: '',
        sendPlaceholder: '',
        chatMessageList: [],
        filteredChatMessageList: [],
        chatMessageBody: '',
        isLoading: false,
        searchInput: '',
        disabledByStatus: false,
        hasChatUsers: true,
        hasAvailableChatUsers: true,
        you: '',
        isPrintingCollab: $state.current.name === 'submission.printCollaboration'
    };

    $scope.chatViewModel.searchPlaceholder = $scope.i18n.searchPlaceholder;
    $scope.chatViewModel.sendPlaceholder = $scope.i18n.sendPlaceholder;
    $scope.chatViewModel.you = $scope.i18n.you;
    $scope.chatViewModel.hasPermission = currentUserModel.hasAuthorization(authorizationConstants.LIVE_CHAT);

    $scope.getDateDividerText = function (chatMessage) {
        const dateTimeSent = moment(chatMessage.dateTimeSent),
            today = moment();

        let dateText;

        if (today.isSame(dateTimeSent, 'day')) {
            dateText = $scope.i18n.today;
        } else {
            if (!today.isSame(dateTimeSent, 'year')) {
                dateText = dateTimeSent.format('MMMM D, YYYY');
            } else {
                dateText = dateTimeSent.format('MMMM D');
            }
        }

        return dateText;
    };

    $scope.isCurrentUser = function (chatMessage) {
        return chatMessage.authorId === currentUserModel.getCurrentUser().userId;
    };

    $scope.getAuthorName = function (chatMessage) {
        const isCurrentUser = $scope.isCurrentUser(chatMessage);
        const isPrintingCollab = $scope.chatViewModel.isPrintingCollab;

        if (isCurrentUser && !isPrintingCollab) {
            return $scope.chatViewModel.you;
        }
        return chatMessage.authorName;
    };

    $scope.shouldShowDateDivider = function (chatMessage) {
        const dateTimeSent = moment(chatMessage.dateTimeSent),
            chatMessageIndex = _.findIndex($scope.chatViewModel.filteredChatMessageList, function (filteredChatMessage) {
                return chatMessage.id === filteredChatMessage.id;
            }),
            today = moment();

        if (chatMessageIndex > 0) {
            const previousChatMessage = $scope.chatViewModel.filteredChatMessageList[chatMessageIndex - 1];
            const previousDateTimeSent = moment(previousChatMessage.dateTimeSent);
            if (!dateTimeSent.isSame(previousDateTimeSent, 'day')) {
                return true;
            }
        } else if (chatMessageIndex === 0 && !today.isSame(dateTimeSent, 'day')) {
            return true;
        }

        return false;
    };

    $scope.shouldShowUserInfo = function (chatMessage) {
        const chatMessageIndex = _.findIndex($scope.chatViewModel.filteredChatMessageList, function (filteredChatMessage) {
            return chatMessage.id === filteredChatMessage.id;
        });

        if (chatMessageIndex > 0) {
            const previousChatMessage = $scope.chatViewModel.filteredChatMessageList[chatMessageIndex - 1];
            return previousChatMessage.authorId !== chatMessage.authorId;
        }

        return true;
    };

    $scope.publish = function (chatMessage) {
        collaborationMediator.publishChatMessage(chatMessage.id);
    };

    $scope.unpublish = function (chatMessage) {
        collaborationMediator.unpublishChatMessage(chatMessage.id);
    };

    $scope.onChatSearchInputChange = function () {
        const scrollToBottom = false;
        processChatMessageList(scrollToBottom);
    };

    $scope.onChatClearSearchInput = function () {
        $scope.chatViewModel.searchInput = '';
        $scope.onChatSearchInputChange();
    };

    $scope.sendChatMessage = function (event) {
        const chatMessage = {};
        if (event.keyCode === 13 && !_.isEmpty(_.trim($scope.chatViewModel.chatMessageBody))) {
            event.preventDefault();
            chatMessage.body = $scope.chatViewModel.chatMessageBody;
            $scope.chatViewModel.chatMessageBody = '';
            collaborationMediator.sendChatMessage($stateParams.submissionId, chatMessage);
        }
    };

    $scope.$on(submissionConstant.event.CREATE_CHAT_MESSAGE, function (event, chatMessage) {
        const scrollToBottom = true;

        $scope.chatViewModel.chatMessageList.push(chatMessage);
        processChatMessageList(scrollToBottom);
    });

    $scope.$on(submissionConstant.event.UPDATE_CHAT_MESSAGE, function (event, chatMessage) {
        const scrollToBottom = false,
            index = _.findIndex($scope.chatViewModel.chatMessageList, function (existingChatMessage) {
                return existingChatMessage.uri === chatMessage.uri;
            });

        if (index !== -1) {
            $scope.chatViewModel.chatMessageList.splice(index, 1, chatMessage);
        } else {
            $scope.chatViewModel.chatMessageList.push(chatMessage);
        }

        processChatMessageList(scrollToBottom);
    });

    $scope.$on(submissionConstant.event.DELETE_CHAT_MESSAGE, function (event, chatMessage) {
        const scrollToBottom = false;

        _.remove($scope.chatViewModel.chatMessageList, function (existingChatMessage) {
            return existingChatMessage.uri === chatMessage.uri;
        });

        processChatMessageList(scrollToBottom);
    });

    $scope.$on('$destroy', function () {
        coreMediator.leaveChat($scope.chatViewModel.submissionId);
        $scope.stopChatMembersPollInterval();
        _.each(timeoutList, function (item) {
            if (item) {
                $timeout.cancel(item);
            }
        });
    });

    $scope.$on(submissionConstant.event.COLLABORATION_DID_CLOSE, function () {
        coreMediator.leaveChat($scope.chatViewModel.submissionId);
        $scope.stopChatMembersPollInterval();
    });

    $scope.$on(submissionConstant.event.COLLABORATION_DID_OPEN, function () {
        coreMediator.enterChat($scope.chatViewModel.submissionId);
        updateChatNotificationRecipients();
        $scope.startChatMembersPollInterval();
    });

    $scope.startChatMembersPollInterval = function () {
        if (_.isNil(chatMemberIntervalObject)) {
            chatMemberIntervalObject = $interval(function () {
                updateChatNotificationRecipients();
            }, chatMemberListPollingInterval);
        }
    };

    $scope.stopChatMembersPollInterval = function () {
        if (!_.isNil(chatMemberIntervalObject)) {
            $interval.cancel(chatMemberIntervalObject);
            chatMemberIntervalObject = null;
        }
    };

    $scope.$on(coreConstant.event.UPDATE_SUBMISSION, function () {
        updateChatNotificationRecipients();
    });

    $scope.$on(submissionConstant.event.CURRENT_SUBMISSION_CHANGE, function () {
        updateChatNotificationRecipients();
    });

    function processChatMessageList(scrollToBottom, initialLoad) {

        function chatMessageListFilterFunction(chatMessage) {
            return _.includes(_.toUpper(chatMessage.body), _.toUpper($scope.chatViewModel.searchInput)) || _.includes(_.toUpper(chatMessage.authorName), _.toUpper($scope.chatViewModel.searchInput));
        }

        $scope.chatViewModel.filteredChatMessageList = _.isEmpty($scope.chatViewModel.searchInput) ? $scope.chatViewModel.chatMessageList : _.filter($scope.chatViewModel.chatMessageList, chatMessageListFilterFunction);

        if (initialLoad && $scope.viewModel.selectedItem && $scope.viewModel.selectedItem.id) {
            $scope.$broadcast(coreConstant.event.SCROLL_TO_ITEM, $scope.viewModel.selectedItem.id);
        } else if (scrollToBottom) {
            $scope.$broadcast(coreConstant.event.SCROLL_TO_BOTTOM);
        }

        timeoutList.push($timeout(function () {
        }, 0));
    }

    function loadChatMessageList() {
        const scrollToBottom = true,
            initialLoad = true;

        $scope.chatViewModel.isLoading = true;
        collaborationMediator.getChatMessageList($stateParams.submissionId).then(function (chatMessageList) {
            $scope.chatViewModel.chatMessageList = chatMessageList;
            processChatMessageList(scrollToBottom, initialLoad);
        }).finally(function () {
            timeoutList.push($timeout(function () {
                $scope.chatViewModel.isLoading = false;
            }, 400));
        });
    }

    function updateChatNotificationRecipients() {
        if (!$stateParams.submissionId) return;
        coreMediator.getChatNotificationRecipients($stateParams.submissionId).then(function (users) {
            let submission = currentSubmissionModel.getCurrentSubmission();
            if (submission && submission.status < submissionStatus.SUBMITTED) {
              $scope.chatViewModel.disabledByStatus = true;
            }
            else {
              $scope.chatViewModel.disabledByStatus = false;
            }
            $scope.chatViewModel.chatMembers = users;
            $scope.chatViewModel.hasChatUsers = users != null && users.length > 1;
            if (!_.isNil($scope.chatViewModel.chatMembers)) {
                let numberOfAvailableChatUsers = 0;
                _.each(users, (user) => {
                    if (user.availableToChat && currentUserModel.getCurrentUser().userId !== user.id) {
                        numberOfAvailableChatUsers++;
                    }
                });

                $scope.chatViewModel.hasAvailableChatUsers = numberOfAvailableChatUsers > 0;
            }
        });
    }

    loadChatMessageList();
    updateChatNotificationRecipients();
    $scope.chatViewModel.submissionId = $stateParams.submissionId;
    coreMediator.enterChat($scope.chatViewModel.submissionId);
    chatMemberListPollingInterval = preferenceModel.get('system.chatMemberListPollingInterval') || submissionConstant.CHAT_MEMBER_LIST_FALLBACK_POLLING_INTERVAL;
    $scope.startChatMembersPollInterval();
};

angular.module('gw-um-submission')
    .controller('collaborationChatController', CollaborationChatController);
